import React from 'react';
import { Route } from 'react-router'; // eslint-disable-line

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import AccommodationType from './accommodation-type';
import CarOrVanAvailability from './car-or-van-availability';
import GeneralHealth from './general-health';
import AgeBySingleYearOfAge from './age-by-single-year-of-age';
import CentralHeating from './central-heating';
import Disability from './disability';
import EconomicActivityStatus from './economic-activity-status';
import EthnicGroup from './ethnic-group';
import HouseholdComposition from './household-composition';
import HouseholdSize from './household-size';
import Industry from './industry';
import MethodOfTravelToWork from './method-of-travel-to-work';
import Occupation from './occupation';
import Religion from './religion';
import Tenure from './tenure';
import NumberOfRooms from './number-of-rooms';
import NumberOfBedrooms from './number-of-bedrooms';
import Sex from './sex';
import CountryOfBirth from './country-of-birth';
import HighestLevelOfQualification from './highest-level-of-qualification';
import ProvisionOfUnpaidCare from './provision-of-unpaid-care';
/* jhipster-needle-add-route-import - JHipster will add routes here */

export default () => {
  return (
    <div>
      <ErrorBoundaryRoutes>
        {/* prettier-ignore */}
        <Route path="accommodation-type/*" element={<AccommodationType />} />
        <Route path="car-or-van-availability/*" element={<CarOrVanAvailability />} />
        <Route path="general-health/*" element={<GeneralHealth />} />
        <Route path="age-by-single-year-of-age/*" element={<AgeBySingleYearOfAge />} />
        <Route path="central-heating/*" element={<CentralHeating />} />
        <Route path="disability/*" element={<Disability />} />
        <Route path="economic-activity-status/*" element={<EconomicActivityStatus />} />
        <Route path="ethnic-group/*" element={<EthnicGroup />} />
        <Route path="household-composition/*" element={<HouseholdComposition />} />
        <Route path="household-size/*" element={<HouseholdSize />} />
        <Route path="industry/*" element={<Industry />} />
        <Route path="method-of-travel-to-work/*" element={<MethodOfTravelToWork />} />
        <Route path="occupation/*" element={<Occupation />} />
        <Route path="religion/*" element={<Religion />} />
        <Route path="tenure/*" element={<Tenure />} />
        <Route path="number-of-rooms/*" element={<NumberOfRooms />} />
        <Route path="number-of-bedrooms/*" element={<NumberOfBedrooms />} />
        <Route path="sex/*" element={<Sex />} />
        <Route path="country-of-birth/*" element={<CountryOfBirth />} />
        <Route path="highest-level-of-qualification/*" element={<HighestLevelOfQualification />} />
        <Route path="provision-of-unpaid-care/*" element={<ProvisionOfUnpaidCare />} />
        {/* jhipster-needle-add-route-path - JHipster will add routes here */}
      </ErrorBoundaryRoutes>
    </div>
  );
};
